import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  userRequest: 'user-request',
  sendMessage: 'user-request/send-message',
  markAsCompleted: 'user-request/complete',
  userRequestByCompany: (companyId: string | number) => `user-request/byCompanyId/${companyId}`,
};

const UserRequestService = {
  createRequest: (data: any) => RequestService.post(endpoints.userRequest, data),
  getAllRequests: () => RequestService.get(endpoints.userRequest),
  getRequestsByCompanyId: (companyId: string | number) => RequestService.get(endpoints.userRequestByCompany(companyId)),
  getRequestById: (id: string | number) => RequestService.get(`${endpoints.userRequest}/${id}`),
  sendRequestMessage: (data: FormData) => RequestService.post(endpoints.sendMessage, data),
  markAsCompleted: (id: string | number) => RequestService.post(`${endpoints.markAsCompleted}/${id}`),
};

export default UserRequestService;
